<template id="config">
    <div>
        <top />
        <el-container>
            <el-aside width="300px">
                <el-menu :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened>
                    <el-submenu v-for="(menu,index) in allmenu" :key="index" :index="menu.menuname">
                        <template #title>
                            <i :class="menu.icon"></i>
                            <span>{{ menu.menuname }}</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item v-for="(chmenu,index) in menu.menus" :index="chmenu.url" :key="index">
                                <span>{{ chmenu.menuname }}</span>
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                </el-menu>
            </el-aside>
            <el-container>
                <router-view></router-view>
            </el-container>
        </el-container>
    </div>
</template>
<script>
    import top from "../components/top.vue";
    export default {
        components: {
            top,
        },
        data() {
            return {
                collapsed: false,
                allmenu: [
                    {
                        menuname: "设置",
                        icon: "el-icon-message",
                        menus: [
                            {
                                menuname: "公开时间",
                                url: "/config/gksj",
                            }, {
                                menuname: "导入表配置",
                                url: "/config/importingProfile",
                            }, {
                                menuname: "密码策略",
                                url: "/config/passwordStrategy",
                            }, {
                                menuname: "PDF配置",
                                url: "/config/pdfConfig",
                            }, {
                                menuname: "CMS配置",
                                url: "/config/cmsConfig",
                            }, {
                                menuname: "公开表配置",
                                url: "/config/MutateTableProfile",
                            }, {
                                menuname: "维护状态配置",
                                url: "/config/maintainConfig",
                            }, {
                                menuname: "创建项目",
                                url: "/config/cloneProject",
                            }, {
                                menuname: "编辑当前项目",
                                url: "/config/editProject",
                            }, {
                                menuname: "删除项目",
                                url: "/config/deleteProject",
                            }
                        ],
                    },
                ],
            };
        },
        created() { },
        mounted() { },
        beforeRouteLeave(to, form, next) {
            next();
        },
        // 销毁之前清楚缓存
        beforeUnmount() { },
        methods: {},
    };
</script>
<style scoped>
    #config {
        background-size: 100% 100%;
        display: flex;
        height: 100vh;
        width: 100%;
        position: relative;
        background: red;
    }

    .el-header {
        box-shadow: 0 0 1px;
        background-color: #e5f2ff;
        color: #333;
        height: 100px !important;
        margin-top: 2%;
        padding: 0;
        position: relative;
        display: flex;
    }

    .el-dropdown-menu,
    .el-menu {
        position: relative;
        background-color: #e3f2fd;
    }

    .el-aside {
        color: #333;
        overflow: hidden !important;
        background-color: #e1f5fe !important;
        height: 90vh;
        box-shadow: 0 8px 10px -5px rgb(0 0 0 / 20%), 0 16px 24px 2px rgb(0 0 0 / 14%), 0 6px 30px 5px rgb(0 0 0 / 12%);
    }

    /* 展示的列表背景色为白色 */
    .el-submenu .el-menu-item {
        height: 50px;
        line-height: 50px;
        padding: 0 45px;
        min-width: 200px;
        background: #fff;
    }
    /* 鼠标移入背景色 */
    .el-menu-item:hover {
        background-color: #808080 !important;
    }
</style>
